import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';
import { ProcessorOptionsCard } from '../components/processor-options-card';

interface TapProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const TapProcessorDetailsPage = ({ processor }: TapProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="tap" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
      <ProcessorOptionsCard processor={processor} />
    </>
  );
};
